import type { LifeInsuranceTariffBase } from "./types";

export const formatLifeInsuranceTariff = (tariff?: LifeInsuranceTariffBase) =>
  tariff ? `${tariff.code} - ${tariff.name}` : undefined;
